module.exports = __webpack_public_path__ + "static/img/frack31.f4923e43.png";